import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';

import { propertyUtils } from '@zg-rentals/rental-manager-env';

import { useSelector } from '../../../../selectors/useSelector';

import { WizardFormSectionContainer, WizardHeading, WizardBody } from '../../../../styles/wizard';

import accessUtils from '../../../../utils/accessUtils';

import RoomSquareFootageFormField from './RoomSquareFootageFormField';
import SquareFootageFormField from './SquareFootageFormField';
import BedroomsFormField from './BedroomsFormField';
import BathroomsFormField from './BathroomsFormField';
import MapPinAdjustmentAlert from '../../../MapPinAdjustmentAlert';

const FormSectionContainer = () => {
  const { appConfig, currentProperty } = useSelector(
    (state) => ({
      appConfig: state.app.appConfig,
      currentProperty: state.properties.currentProperty,
    }),
    shallowEqual,
  );

  const canAccessNoWelcomePageML = accessUtils.canAccessNoWelcomePageML({ appConfig });

  const isRoomForRent = propertyUtils.isRoomForRent({ currentProperty });

  const heading = useMemo(() => {
    if (isRoomForRent) {
      return 'Confirm some facts about the room and property';
    }

    return canAccessNoWelcomePageML
      ? `Let's start creating your listing`
      : 'Confirm some facts about your rental property';
  }, [isRoomForRent, canAccessNoWelcomePageML]);

  return (
    <WizardFormSectionContainer data-testid="FormSectionContainer">
      {!isRoomForRent && <MapPinAdjustmentAlert />}
      <WizardHeading textStyle="heading-sm" level={1}>
        {heading}
      </WizardHeading>

      {Boolean(canAccessNoWelcomePageML && !isRoomForRent) && (
        <WizardBody>Add or review details about your property&apos;s size.</WizardBody>
      )}

      {isRoomForRent && <RoomSquareFootageFormField />}
      <SquareFootageFormField />
      <BedroomsFormField />
      <BathroomsFormField />
    </WizardFormSectionContainer>
  );
};

export default FormSectionContainer;
